// ================================
// User Rights Utility
// ================================

let userRights = [];

function normalizeRight(value) {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
}

// DEBUG ONLY
window.getUserRights = getUserRights;
window.hasRight = hasRight;

// --------------------------------
// Hide elements based on data-right
// --------------------------------
export function applyRightsToDOM() {

    document.documentElement.classList.remove("rights-ready");

    // Hide protected controls first, then reveal only the controls allowed by rights.
    document.querySelectorAll('[data-right]').forEach(el => {
        const rights = el.getAttribute('data-right');
        const allowed = rights
            .split(',')
            .some(r => hasRight(r.trim()));

        el.style.display = allowed ? "" : "none";
    });

    document.documentElement.classList.add("rights-ready");
}

// --------------------------------
// Set rights (call after login/API)
// --------------------------------
export function setUserRights(rightsInput) {

    if (Array.isArray(rightsInput)) {
        userRights = rightsInput
            .map(r => r.trim())
            .filter(r => r.length > 0);
    }
    else if (typeof rightsInput === "string") {
        userRights = rightsInput
            .split(";")
            .map(r => r.trim())
            .filter(r => r.length > 0);
    }
    else {
        userRights = [];
    }
}

// --------------------------------
// Get all rights
// --------------------------------
export function getUserRights() {
    return userRights;
}

// --------------------------------
// Check single right
// --------------------------------
export function hasRight(rightName) {
    if (!rightName) return false;
    const expected = normalizeRight(rightName);
    return userRights.some(right => normalizeRight(right) === expected);
}

// --------------------------------
// Check any right from list
// --------------------------------
export function hasAnyRight(rightList) {
    if (!Array.isArray(rightList)) return false;
    return rightList.some(r => hasRight(r));
}

// --------------------------------
// Check all rights from list
// --------------------------------
export function hasAllRights(rightList) {
    if (!Array.isArray(rightList)) return false;
    return rightList.every(r => hasRight(r));
}

// --------------------------------
// Show / Hide element by right
// --------------------------------
export function toggleElementByRight(elementId, rightName) {
    const el = document.getElementById(elementId);
    if (!el) return;

    if (hasRight(rightName)) {
        el.style.display = "";
    } else {
        el.style.display = "none";
    }
}

// --------------------------------
// Enable / Disable button
// --------------------------------
export function enableElementByRight(elementId, rightName) {
    const el = document.getElementById(elementId);
    if (!el) return;

    el.disabled = !hasRight(rightName);
}

// --------------------------------
// Apply rights to multiple elements
// --------------------------------
export function applyRights(config) {
    /*
      Example config:
      [
        { id: "uploadBtn", right: "data.upload" },
        { id: "infoBtn", right: "map.info" }
      ]
    */

    if (!Array.isArray(config)) return;

    config.forEach(item => {
        if (!item.id || !item.right) return;
        toggleElementByRight(item.id, item.right);
    });
}
